import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import XIcon from '@mui/icons-material/X'
import YouTubeIcon from '@mui/icons-material/YouTube'
import { Box, IconButton, SvgIcon } from '@mui/material'
import { Colors } from '~/components/ui/color'
import { URLConstants } from '~/libs/constants'

const SOCIAL_MEDIA_INFO = {
  instagram: { icon: InstagramIcon, href: URLConstants.instagramPage },
  facebook: { icon: FacebookIcon, href: URLConstants.facebookPage },
  x: { icon: XIcon, href: URLConstants.xPage },
  youtube: { icon: YouTubeIcon, href: URLConstants.youtubePage },
}

export const AppFooterSocialLinks = () => {
  return (
    <Box display='flex' alignItems='center' gap='24px'>
      {Object.entries(SOCIAL_MEDIA_INFO).map(([name, { icon, href }]) => (
        <IconButton
          key={name}
          href={href}
          target='_blank'
          aria-label={name}
          sx={{
            color: Colors['Base/White'],
            padding: 0,
            minHeight: 0,
            '&:hover': {
              color: Colors['Samansa_Yellow/500'],
              backgroundColor: 'transparent',
            },
          }}
        >
          <SvgIcon component={icon} sx={{ fontSize: '24px' }} />
        </IconButton>
      ))}
    </Box>
  )
}
